export default function uniqueAlertRecipientEmailDirective(
  $q,
  orgDataService
) {
  return {
    restrict: 'A',
    require: '?ngModel',
    link,
  };

  function link(scope, element, attributes, ngModel) {
    const vendorId = attributes.vendorId || -1;
    const alertRecipientId = attributes.alertRecipientId || -1;
    ngModel.$asyncValidators.uniqueAlertRecipientEmail = modelValue => orgDataService.checkVendorAlertRecipientEmail(
      vendorId, alertRecipientId, modelValue
    )
      .then((data) => {
        if (data && !data.data.result) {
          return $q.resolve();
        }
        return $q.reject();
      })
      .catch(() => $q.reject());
  }
}

export const name = 'uniqueAlertRecipientEmail';

uniqueAlertRecipientEmailDirective.$inject = [
  '$q',
  'orgDataService'
];
